
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import NewCardModal from "@/components/modals/forms/NewCardModal.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
//import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import * as Yup from "yup";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Avatar from "vue-avatar-component";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";

interface Buscador {
  estado?: number;
  factura?: number;
  empresaId?: number;
  fechaInicio?: Date;
  fechaTermino?: Date;
  proveedorId: number;
}

export default defineComponent({
  name: "overview",
  components: {
    DataTable,
    Column,
    Avatar,
    //ErrorMessage,
    //Field,
    //Form,
    NewCardModal,
  },
  data() {
    return {
      store: useStore(),
      router: useRouter(),
    };
  },
  methods: {
    estados() {
      const estados = _.chain(this.store.getters.allFacturas)
        .groupBy("detalleEstado")
        .map((value, key) => ({ estado: key, facturas: value }))
        .value();
      return estados;
    },
    empresass() {
      const empresas = _.chain(this.store.getters.allFacturas)
        .groupBy("nombreEmpresa")
        .map((value, key) => ({ empresa: key, facturas: value }))
        .value();
      return empresas;
    },
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    estadoActual(value) {
      return value ? "APROBADO" : "PENDIENTE DE APROBACIÓN";
    },
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },
  setup() {
    const confirm = useConfirm();
    const toast = useToast();
    const submitButton1 = ref<HTMLElement | null>(null);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const id = route.params.id;
    const aprobar = (event) => {
      let solicitud = currentSolicitud.value;
      solicitud.activado = true;
      solicitud.usuarioActivador = currentUser.value.contactoNombre;
      confirm.require({
        target: event.currentTarget,
        message: "¿Está seguro de aprobar la cuenta?",
        icon: "pi pi-info-circle",
        acceptLabel: "Si",
        rejectLabel: "No",
        acceptClass: "p-button-danger",
        accept: () => {
          store
            .dispatch(Actions.UPD_SOLICITUD, solicitud)
            .then(() => {
              Swal.fire({
                text: "Solicitud Aprobada. Se ha creado el Usuario y enviada las credenciales al correo electrónico",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary",
                },
              }).then(function () {
                // Go to page after successfully login
                router.push({ name: "apps-subscriptions-listing" });
                //router.push({ name: "dashboard" });
              });
            })
            .catch(() => {
              const [error] = Object.keys(store.getters.getEmpresaErrors);
            });
        },
        reject: () => {
          toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "You have rejected",
            life: 3000,
          });
        },
      });
    };
    const rechazar = (event) => {
      confirm.require({
        target: event.currentTarget,
        message: "Está seguro de rechazar la solicitud?",
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        accept: () => {
          router.push({ name: "apps-subscriptions-listing" });
        },
        reject: () => {
          toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "You have rejected",
            life: 3000,
          });
        },
      });
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs("Mis Facturas", ["Página", "Dashboard"]);
      store
        .dispatch(Actions.GET_SOLICITUD, id)
        .then(() => {
          buscarFacturas(store.getters.currentSolicitud.rutProveedor);
          buscarProveedor(store.getters.currentSolicitud.rutProveedor);
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getEmpresaErrors);
        });
    });

    const buscarFacturas = (rut) => {
      store
        .dispatch(Actions.GET_FACTURAS_REFERENCIA, rut)
        .then(() => {
          loading.value = false;
          // submitButton1.value?.removeAttribute("data-kt-indicator");
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
        });
    };
    const buscarProveedor = (rut) => {
      store
        .dispatch(Actions.GET_PROVEEDOR_RUT, rut)
        .then(() => {
          loading.value = false;
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
        });
    };
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    const currentProveedor = computed(() => {
      return store.getters.currentProveedor;
    });
    const currentSolicitud = computed(() => {
      return store.getters.currentSolicitud;
    });
    const empresas = computed(() => {
      return store.getters.allEmpresas;
    });
    const filters1 = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      numeroFactura: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      nombreEmpresa: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      detalleEstado: { value: null, matchMode: FilterMatchMode.IN },
      date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
      verified: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const search = ref(null);
    const selectedCustomers = ref(null);

    const statuses = ref([
      "unqualified",
      "qualified",
      "new",
      "negotiation",
      "renewal",
      "proposal",
    ]);
    const loading = ref(true);
    return {
      filters1,
      aprobar,
      rechazar,
      empresas,
      statuses,
      selectedCustomers,
      loading,
      buscarFacturas,
      submitButton1,
      currentSolicitud,
      buscarProveedor,
      currentUser,
      currentProveedor,
    };
  },
});
